import * as Yup from 'yup'

export const infoFormValues = {
    email_verified: "0",
    retailer_type: "",
    activate_bank_payment: "",
    activate_net30: "",
    email: "",
    password: "",
    license_number: "",
    // business_license: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    company_name: "",
}

export const addressFormValues = {
    address_type: "",
    address_shipping_first_name: "",
    address_shipping_middle_name: "",
    address_shipping_last_name: "",
    address_shipping_company_name: "",
    address_shipping_address: "",
    address_shipping_address1: "",
    address_shipping_city: "",
    address_shipping_country: "",
    address_shipping_state: "",
    address_shipping_zipcode: "",
    address_shipping_phone: "",
    address_shipping_mobile: "",
    address_shipping_fax: "",
}

export const formValidationSchema = Yup.object({
    first_name: Yup.string().required('This field is required'),
    last_name: Yup.string().required('This field is required'),
    password: Yup.string()
        .required('This field is required')
        .matches(/^(?=.{8,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/, "Password must have a small letter, a capital letter, a number, and a symble"),
    email: Yup.string().email('Invalid email address').required('This field is required'),
})

export const addressFormVS = Yup.object({
    address_type: Yup.string().required("This field is required"),
    address_shipping_first_name: Yup.string().required("This field is required"),
    // address_shipping_middle_name: Yup.string().required("This field is required"),
    address_shipping_last_name: Yup.string().required("This field is required"),
    // address_shipping_company_name: Yup.string().required("This field is required"),
    address_shipping_address: Yup.string().required("This field is required"),
    // address_shipping_address1: Yup.string().required("This field is required"),
    address_shipping_city: Yup.string().required("This field is required"),
    address_shipping_country: Yup.string().required("This field is required"),
    address_shipping_state: Yup.string().required("This field is required"),
    // address_shipping_zipcode: Yup.string().required("This field is required"),
    // address_shipping_phone: Yup.string().required("This field is required"),
    address_shipping_mobile: Yup.string()
        .required("This field is required")
        .min(8, 'Invalid number')
        .max(12, 'Invalid number')
    // address_shipping_fax: Yup.string().required("This field is required")
})

export const isDetailsFilled = (values) => {
    return (values.first_name &&
        values.middle_name &&
        values.last_name &&
        values.company_name &&
        values.password &&
        values.retailer_type &&
        values.email && true)

}
export const isAddressFilled = (values) => {
    return (values.address_type &&
        values.address_shipping_first_name &&
        values.address_shipping_middle_name &&
        values.address_shipping_last_name &&
        values.address_shipping_company_name &&
        values.address_shipping_address &&
        values.address_shipping_address1 &&
        values.address_shipping_city &&
        values.address_shipping_country &&
        values.address_shipping_state &&
        values.address_shipping_zipcode &&
        values.address_shipping_phone &&
        values.address_shipping_mobile &&
        values.address_shipping_fax && true)
}